import { ArticleCard, ArticleCardData } from "@baseComponents/ArticleCard";
import { useMediaQueryBreakpoint } from "@hooks";

import {
  ProjectsGroupInnerContainer,
  ProjectsGroupOuterContainer,
} from "./ArticlesMainLayout.styled";

interface ArticlesMainLayoutProps {
  articles: ArticleCardData[];
  className?: string;
}

export const ArticlesMainLayout = ({
  articles: [firstArticle, ...otherArticles],
  className,
}: ArticlesMainLayoutProps) => {
  const { isDesktop, isTablet, tabletThreshold, desktopThreshold } =
    useMediaQueryBreakpoint();

  return (
    <ProjectsGroupOuterContainer className={`${className}`}>
      {firstArticle && (
        <ArticleCard
          size={isDesktop ? "big" : isTablet ? "medium" : "small"}
          {...firstArticle}
          nextImageSizes={`(min-width: ${desktopThreshold}px) 60vw, 100vw`}
        />
      )}

      <ProjectsGroupInnerContainer>
        {otherArticles.map(article => (
          <ArticleCard
            size={isTablet ? "medium" : "small"}
            {...article}
            key={article.href}
            nextImageSizes={`(min-width: ${tabletThreshold}px) 50vw, 100vw`}
          />
        ))}
      </ProjectsGroupInnerContainer>
    </ProjectsGroupOuterContainer>
  );
};
